export class CompanyIdentifier {
  id: number;
  identifierValue: string;
  companyIdentifierTypeId: number;

  constructor(type: any = {}) {
    this.id = type.id || null;
    this.identifierValue = type.identifierValue || null;
    this.companyIdentifierTypeId = type.companyIdentifierTypeId || null;
  }
}
